import React, { Fragment } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from '../modules/Home';
import Product from '../modules/Product';
import Layout from './Layout';
import Company from '../modules/Company';
import Partners from '../modules/Partners';
import Preview from '../modules/Preview';

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Fragment>
        <Routes>
          <Route path="/" element={<Preview />} />
          <Route path="/" element={<Layout />}>
            <Route path="/old" element={<Home />} />
            <Route path="preview" element={<Preview />} />
            <Route path="product" element={<Product />} />
            <Route path="company" element={<Company />} />
            <Route path="partners" element={<Partners />} />
            <Route path="*" element={<Navigate to={'/'} />} />
          </Route>
        </Routes>
      </Fragment>
    </BrowserRouter>
  );
}
